var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isCustomerIcon)?_c('i',{class:['iconfont',_vm.getCustomerIconType],style:(_vm.customerIconStyle)}):_c('Icon',{attrs:{"type":_vm.type,"color":_vm.color,"size":_vm.size}})}
var staticRenderFns = []

export { render, staticRenderFns }